module.exports = __webpack_public_path__ + "static/media/software.61b703bb.png";